// Libraries
import React, { useContext } from 'react';

// Components
import DmaStepper from './DmaStepper';
import Copyright from './Copyright';

// Services and Contexts
import LanguageContext from '../contexts/LanguageContext';
import { QuestionsProvider } from '../contexts/QuestionsContext';
import { RatingsProvider } from '../contexts/RatingsContext';

//Material-UI
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function Dma() {
  const { translate } = useContext(LanguageContext);

  return (
    <QuestionsProvider>
      <RatingsProvider>
        <Box mt={2} mx="auto" maxWidth="900px">
          <Paper elevation={4}>
            <Box textAlign="center" pt={4} pb={2}>
              <Typography variant="h4">{translate('GLOBAL_HEADING_DMA')}</Typography>
            </Box>
            <DmaStepper />
          </Paper>
        </Box>
        <Copyright />
      </RatingsProvider>
    </QuestionsProvider>
  );
}
